module.exports = __webpack_public_path__ + "img/ic_referbanner.e9995834.png";